export const TOOTH_WIDTH_MM = 10
export const RECOMMENDED_MIN_HEIGHT_MM = 4

const PARKER_THRESHOLDS = [
  { height: 1, maxToc: 5.8 },
  { height: 2, maxToc: 11.6 },
  { height: 3, maxToc: 17.4 },
  { height: 4, maxToc: 21.8 },
] as const

/**
 * Returns the maximum TOC that retains resistance for a 10 mm-wide molar.
 * This preserves the piecewise interpolation and >4 mm extrapolation used by
 * the original 2D simulator.
 */
export function calculateMaxResistantToc(heightMm: number): number {
  if (heightMm <= 0) return 0
  if (heightMm < 1) return heightMm * 5.8

  for (let index = 0; index < PARKER_THRESHOLDS.length - 1; index += 1) {
    const start = PARKER_THRESHOLDS[index]
    const end = PARKER_THRESHOLDS[index + 1]
    if (heightMm <= end.height) {
      const progress = (heightMm - start.height) / (end.height - start.height)
      return start.maxToc + progress * (end.maxToc - start.maxToc)
    }
  }

  return 21.8 + (heightMm - 4) * 5.8
}

export function hasResistance(heightMm: number, tocDeg: number): boolean {
  return tocDeg <= calculateMaxResistantToc(heightMm)
}
